import axios from "axios";

const apiClientForPScreen = axios.create({
  // baseURL: `https://api.mushgpt.com/`,
  // baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  baseURL: `https://api.psiloscreen.me/`,
  // baseURL: `https://dev-api.psiloscreen.me/`,
  // baseURL: process.env.REACT_APP_API_PSCREEN_URL,
});

export default apiClientForPScreen;
